<template>
  <div>
    <!-- Data Stores Hack, need to be loaded first -->
    <SLGATransactionStore ref="transactionStore"/>
    <!-- ///////////////////////////////////////// -->

    <h1>SLGA Transaction Report</h1>
    <p>ℹ️ Info: This report of transactions, set out by SLGA's Transaction Type Template.</p>
    <GenericDatePeriodSelector storeName="transactionStore" />
    <GenericDaysSelector storeName="transactionStore" />
    
    <ExportToExcel 
      :tables="['CCS']" 
      bookName="SLGA Transaction Report"
      storeName="transactionStore"
      dateFormat="yyyy-mm-dd hh:mm:ss"
    />
    
    <SLGATable storeName="transactionStore" location="CCS"/>
    <div class="pagebreak"> </div>
    <!-- <SLGATable storeName="transactionStore" location="RMGB"/> -->
    <div class="pagebreak"> </div>
    <!-- <SLGATable storeName="transactionStore" location="WGB"/> -->
    
  </div>
</template>

<script>
import SLGATransactionStore from '@/pages/Reports/SLGA/Stores/SLGATransactionStore.vue'
import SLGATable from '@/pages/Reports/SLGA/Components/SLGATable.vue'


export default {
  name: 'SLGATransactionReport',
  components:{ SLGATable, SLGATransactionStore},
  provide(){
    return {
      posPage: this,
      page: this,
    }
  },
  computed:{
    // timestamps(){return this.$refs.posStore.timestamps},
  },
  methods:{
  }
}
</script>